// import axios from 'axios';
// import { useState,useEffect } from 'react';
// import { useNavigate } from 'react-router-dom'
import React from 'react'

import data from '../db'


function Entertainmentpage({
  img,category,title,desc
}) {

return (
      <>
    
    <div style={{width:"65%",height:"650px",margin:"auto"}}>
      
      <div >
          <a href="https://www.firstpost.com/category/entertainment"><img style={{width:"100%"}} src={img}/></a>
      </div>

      
      <div style={{borderBottom:"4px solid #f3a342",width:"70px",marginBottom:"10px"}}>{category}</div>
      <p style={{ font: "Playfair Display",fontSize: "25px",fontWeight: "bold" }}>{title}</p>
      <div >{desc}</div>
      
  </div>
  </>
)
}

const Entertainment = () => {

  return (
    <>
    <p style={{marginBottom:"20px",marginTop:"30px",marginLeft:"660px",fontWeight:"600",width:"340px",fontSize:"30px",borderBottom:"5px solid #f3a342"}}>ENTERTAINMENT NEWS</p>
    <div>
        {
          data.Entertainment.map(item =>
            <Entertainmentpage key={item.id} {...item}/>
            )
        }
      </div>
      </>
  )
}

export default Entertainment;